import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, onAuthStateChanged } from 'firebase/auth';

import { firebaseConfig } from './firebase-config.js';

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

const signInButton = document.querySelector('.google-signin');

const redirectToDashboard = () => {
  window.location.href = 'dashboard.html';
};

signInButton.addEventListener('click', async () => {
  try {
    await signInWithPopup(auth, provider);
    redirectToDashboard();
  } catch (error) {
    console.error('Google sign-in failed:', error);
    alert('Unable to sign in with Google. Please try again.');
  }
});

onAuthStateChanged(auth, user => {
  if (user) {
    redirectToDashboard();
  }
});
